import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PayeeButtonComponent } from 'src/app/shared/payee-buttons/payee-button/payee-button.component';
import { ChipDropdownComponent } from 'src/app/shared/payee-cases/chip-dropdown/chip-dropdown.component';
import { PayeeFormFieldComponent } from 'src/app/shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from 'src/app/shared/payee-input/payee-input.directive';
import { EventsService } from '../events.service';

@Component({
  selector: 'app-events-case-id-filter',
  templateUrl: './events-case-id-filter.component.html',
  imports: [
    FormsModule,
    ChipDropdownComponent,
    PayeeFormFieldComponent,
    ReactiveFormsModule,
    PayeeButtonComponent,
    PayeeInputDirective,
    TranslateModule,
  ],
})
export class EventsCaseIdFilterComponent implements OnInit, OnDestroy {
  private eventsService = inject(EventsService);

  private readonly destroy = new Subject<void>();
  readonly caseIdControl = new FormControl<string | null>('', [
    Validators.required,
    Validators.minLength(3),
  ]);

  dropdownOpen = false;

  get selected() {
    return this.eventsService.payee_case_reference_id.value;
  }

  ngOnInit(): void {
    this.eventsService.payee_case_reference_id
      .pipe(takeUntil(this.destroy))
      .subscribe((v) => this.caseIdControl.patchValue(v));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  applyFilter(): void {
    if (this.caseIdControl.invalid) {
      this.caseIdControl.markAsDirty();
      return;
    }

    this.eventsService.payee_case_reference_id.next(this.caseIdControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.eventsService.payee_case_reference_id.next(null);
    this.dropdownOpen = false;
  }

  displayWith(selected: string): string {
    return selected;
  }

  onPaste(_event: ClipboardEvent): void {
    this.caseIdControl.markAsTouched();
    setTimeout(() => {
      this.applyFilter();
    });
  }
}
